//set the connection strings according to the used environment
export const serverConnection = process.env.REACT_APP_SERVER_ADDRESS;
export const socketConnection = process.env.REACT_APP_SOCKET_ADDRESS;
export const header = process.env.REACT_APP_HEADER;